(function ($, Drupal, once) {
  'use strict';

  /**
   * Main Menu Click Function.
   */
  const MenuToggle = function (drupalMenu, event) {
    updateBackButton(drupalMenu);
    let clickedEntry = $(event.target);
    if (clickedEntry[0].tagName === 'UL') {
      event.preventDefault();
      return false;
    }

    // Walk up to the nearest enclosing menu-item. Leaf items (no children)
    // always navigate directly — previously this check used a raw .parent()
    // which missed cases where the click target was a nested span/icon
    // inside the link and would wrongly fall through the toggle logic.
    const clickedLi = clickedEntry.closest('li.menu-item');
    if (clickedLi.length && !clickedLi.hasClass('menu-item--expanded')) {
      return true;
    }

    clickedEntry = clickedEntry.parent();
    if (!clickedEntry.hasClass('menu-item--expanded')) {
      return true;
    }
    event.preventDefault();
    let rootMenuEntry = clickedEntry.closest('.menu-level-1').parent();
    clickedEntry.addClass('open');
    rootMenuEntry.length > 0 ? rootMenuEntry.addClass('open') : null;
    drupalMenu.find('.menu-item').each(function () {
      const currentMenu = $(this);
      currentMenu.hasClass('open') ? currentMenu.removeClass('open') : currentMenu.addClass('closed');
    });
    clickedEntry.toggleClass('closed');
    let parent = clickedEntry.parent().parent();
    clickedEntry.hasClass('closed') ? parent.removeClass('borderless') : parent.addClass('borderless');
    updateBackButton(drupalMenu);
  };

  /**
   * Show or hide the back icon, depending on the open menu items.
   */
  const updateBackButton = (drupalMenu) => {
    const openMenus = drupalMenu.find('.menu-item:not(.closed)');
    const backArrow = $('.operations .back .fa-arrow-left');
    if (openMenus.length > 0) {
      backArrow.removeClass('js-hide');
    } else {
      backArrow.addClass('js-hide');
    }
  };

  /**
   * Toggle main menu visibility.
   */
  const showHideMenu = (drupalMenu) => {
    drupalMenu.toggleClass('visible');
    drupalMenu.find('.open').removeClass('open');
    drupalMenu.find('.menu-item:not(.closed)').addClass('closed');
    drupalMenu.find('.borderless').removeClass('borderless');
    $('body').toggleClass('no-scroll');
    updateBackButton(drupalMenu);
  };

  /**
   * Quickmenu click handler. HWSGR exposes the full hierarchy via desktop
   * dropdowns, so the fly-in is never opened from the quickmenu — every
   * click navigates directly. The hamburger still opens the fly-in for
   * mobile via showHideMenu.
   */
  const menuDeepLink = () => true;

  /**
   * Attach menu behavior. Runs on initial page load and after every AJAX
   * response, guarded by once() so handlers are only attached a single time
   * per element. Uses Drupal.behaviors so it is safe to load the script
   * either in the header or footer — attachment waits for DOM readiness.
   */
  Drupal.behaviors.hwsgrNavigation = {
    attach: function (context) {
      const menuNodes = once('hwsgr-navigation', '#block-hwsgr-main-menu, #block-ibw-main-menu', context);
      if (menuNodes.length === 0) {
        return;
      }
      const drupalMenu = $(menuNodes);
      const quickMenu = $('#block-hwsgr-quickmainmenu, #block-quickmainmenu', context);

      // Copy Menu parents to sub-menus as clickable link.
      drupalMenu.find('.menu-item--expanded').each(function () {
        const item = $(this);
        if (!item.data('menu-cloned')) {
          item.find('> a').clone().wrap('<li></li>').prependTo(item.find('> .menu'));
          item.data('menu-cloned', true);
        }
      });

      // Menu Entry click listener.
      drupalMenu.on('click', (event) => MenuToggle(drupalMenu, event));

      // Operations click listeners.
      drupalMenu.find('.operations .back').on('click', function () {
        let openMenus = drupalMenu.find('.menu-item:not(.closed)');
        $(openMenus[openMenus.length - 1]).addClass('closed');
      });

      // Show and hide the main menu.
      drupalMenu.find('.operations .close, .background').on('click', () => showHideMenu(drupalMenu));
      quickMenu.find('.menu-icon').on('click', () => showHideMenu(drupalMenu));

      // Show the main menu and navigate to deep-link.
      quickMenu.find('ul.menu li.menu-item a').on('click', (event) => menuDeepLink(drupalMenu, event));
    },
  };
})(jQuery, Drupal, once);
